import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { AnalyticsListener as AkAnalyticsListener } from '@atlaskit/analytics-next';
import { getMergedMarketplaceContext, SCREEN_EVENT_TYPE } from '@atlassian/mpac-analytics';
import { Option } from 'funfix-core';
import * as React from 'react';
import { withMountPath } from '../../../components/AppContext';
import { EmceeVariant } from '../../../constants/EmceeVariants';
import { getExtensionIDFromURL } from '../../../services/AP';
import { getNonScreenEvent, getScreenViewEvent } from '../../../utils/analytics-utils';
import { isEmceeConnect } from '../../../utils/package-connect-utils';
import { resolveCurrentRoute } from '../../../utils/routes-utils';
import { getAnalyticsRouteParams, getAnalyticsSourceParam } from '../../commonUtils';
import { sendEvent, sendPageViewEvent } from '../../Send';
export const ALLOWED_CHANNELS = new Set(['addonDiscovery', 'marketplace']);
export class AnalyticsListenerBase extends React.Component {
  constructor() {
    super(...arguments);
    _defineProperty(this, "onEvent", (event, channel) => {
      const gasEvent = event;
      if (channel && ALLOWED_CHANNELS.has(channel)) {
        const {
          payload,
          context
        } = gasEvent;
        const source = Option.of(this.props.analytics.modalStack.last()).getOrElse(this.props.analytics.currentScreen);
        const marketplaceContext = getMergedMarketplaceContext(context);
        const emceeVariant = isEmceeConnect() ? EmceeVariant.Connect : EmceeVariant.Native;
        getExtensionIDFromURL(extensionID => {
          const featureFlags = this.props.featureFlags.getAllFlags().toJS();
          const sourceUrlParam = getAnalyticsSourceParam();
          const baseAttributes = {
            featureFlags,
            source: sourceUrlParam,
            extensionID,
            emceeVariant,
            launchDarklyUserKey: this.props.launchDarklyUserKey
          };
          const tags = (payload.tags || []).concat(['emcee']);
          const updatedPayload = _objectSpread(_objectSpread({}, payload), {}, {
            tags
          });
          if (payload.eventType.type === SCREEN_EVENT_TYPE) {
            const analyticsRouteParams = getAnalyticsRouteParams({
              mountPath: this.props.mountPath
            });
            const eventArgs = {
              marketplaceContext,
              payload: updatedPayload,
              analyticsRouteParams
            };
            const finalEvent = getScreenViewEvent(eventArgs);
            return sendPageViewEvent(finalEvent);
          }

          // all other events
          const eventArgs = {
            marketplaceContext,
            payload: updatedPayload,
            source,
            baseAttributes
          };
          const finalEvent = getNonScreenEvent(eventArgs);
          sendEvent(finalEvent);
        });
      }
    });
  }
  onScreenChanged(currentPath) {
    const currentRoute = resolveCurrentRoute(currentPath, this.props.mountPath);
    if (currentRoute) {
      this.props.onScreenChanged(currentRoute.analyticsSourceScreen, {
        mountPath: this.props.mountPath
      });
    } else {
      throw new Error("Must register a route in Routes.js for: ".concat(currentPath));
    }
  }
  componentDidMount() {
    this.onScreenChanged(this.props.location.pathname);
  }
  componentDidUpdate(prevProps) {
    if (this.props.location.pathname !== prevProps.location.pathname) {
      this.onScreenChanged(this.props.location.pathname);
    }
  }
  render() {
    return /*#__PURE__*/React.createElement(AkAnalyticsListener, {
      channel: "*",
      onEvent: this.onEvent
    }, this.props.children);
  }
}
export default withMountPath(AnalyticsListenerBase);